const BaseUrl = `${process.env.REACT_APP_API_URL}`;
const enrolleeDetailAPI =`${BaseUrl}/v1/get_enrollee_details`;
const preEmployAPI = `${BaseUrl}/v1/comprehensive/care/pe`
export {
    BaseUrl,
    enrolleeDetailAPI,
    preEmployAPI
}